import React, { Component } from 'react';
import classNames from 'classnames';

import rightArrow from '../../assets/images/RightArrow.svg';
import './button.css';

export default class Button extends Component {
  render() {
    return (
      <button onClick={this.props.onClick} className={classNames(this.props.styleButton)} 
        disabled={this.props.disabled} id={this.props.id}>
        {this.props.iconSource ? <img className="icon-add" src={this.props.iconSource} alt="" /> : ''}
        {this.props.text}
        {this.props.icon ? <img src={rightArrow} alt="" /> : ''}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js